import script from "./compPostsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./compPostsTable.vue?vue&type=script&setup=true&lang=js"

import "./compPostsTable.vue?vue&type=style&index=0&id=8bfdd184&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bfdd184"]])

export default __exports__